var render = function render(){var _vm=this,_c=_vm._self._c;return _c('vue-element-loading',{attrs:{"active":_vm.status,"color":"#03543f","is-full-screen":_vm.fullPage}})
}
var staticRenderFns = []

export { render, staticRenderFns }